import {
    IIntercomState,
    initialIntercomState
} from './intercom-state';

export function reducer(state: IIntercomState = initialIntercomState(), action: any): IIntercomState {
    switch (action.type) {
        default:
            return state;
    }
}
